<template>

    <div>
        <div class="share-div">
            <div class="">
                <button class="btn btn-print" @click="printPage()"><i
                        class="fa fa-print"></i>
                    Printable Page
                </button>
                <button class="btn btn-envelop" @click="displayModal()">
                    <i class="fa fa-envelope"></i> Email This Page
                </button>
                <button class="btn btn-heart" id="bookmark" @click="saveToFav()"><i class="fa fa-heart"></i> Save To
                    Favorites
                </button>
            </div>
        </div>


        <transition name="modal" v-if="showModal == true">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <button class="modal-default-button" @click="closeModal()">
                            <i class="far fa-times-circle"></i>
                        </button>
                        <!-- <div class="modal-header">
                            <slot name="header">
                                default header
                            </slot>
                        </div> -->

                        <div class="modal-body">
                            <slot name="body">
                                <form class="feedback" name="feedback" id="feedback-form" @submit.prevent="send()">
                                    <div class="form-group">
                                        <label>Recipient Name</label>
                                        <input type="text" class="form-control" name="recipient_name"
                                               v-model="formFields.recipient_name">

                                        <span v-if="formErrors && formErrors.recipient_name" class="text-danger">{{ formErrors.recipient_name[0] }}</span>

                                    </div>
                                    <div class="form-group">
                                        <label>Recipient Email</label>
                                        <input type="email" class="form-control" name="recipient_email"
                                               v-model="formFields.recipient_email">
                                        <span v-if="formErrors && formErrors.recipient_email" class="text-danger">{{ formErrors.recipient_email[0] }}</span>

                                    </div>
                                    <div class="form-group">
                                        <label>Your Name</label>
                                        <input type="text" class="form-control" name="your_name"
                                               v-model="formFields.your_name">
                                        <span v-if="formErrors && formErrors.your_name" class="text-danger">{{ formErrors.your_name[0] }}</span>

                                    </div>
                                    <div class="form-group">
                                        <label>Your Email</label>
                                        <input type="email" class="form-control" name="your_email"
                                               v-model="formFields.your_email">
                                        <span v-if="formErrors && formErrors.your_email" class="text-danger">{{ formErrors.your_email[0] }}</span>

                                    </div>
                                    <div class="form-group">
                                        <label>Comment</label>
                                        <textarea type="email" class="form-control" name="your_comment"
                                                  v-model="formFields.your_comment"></textarea>

                                        <span v-if="formErrors && formErrors.your_comment" class="text-danger">{{ formErrors.your_comment[0] }}</span>
                                    </div>
                                    <button id="submitBtn" class="btn btn-primary" :disabled="submitDisabled">
                                        {{this.submitButton}}
                                    </button>
                                </form>
                            </slot>
                        </div>

                        <!-- <div class="modal-footer">
                            <slot name="footer">
                                default footer
                            </slot>
                        </div> -->
                    </div>
                </div>
            </div>
        </transition>


    </div>
</template>


<script>

    import axios from 'axios'

    import VueSweetalert2 from 'vue-sweetalert2';

    Vue.use(VueSweetalert2);

    import VueToast from 'vue-toast-notification';
    import 'vue-toast-notification/dist/index.css';


    Vue.component('pagination', require('laravel-vue-pagination'));
    export default {
        components: {},
        data: function () {
            return {
                showModal: false,
                submitButton: 'Submit',
                submitDisabled: false,
                formFields: {},
                formErrors: {},
            }
        },
        methods: {
            printPage() {
                console.log('Print Page');
                window.print();
            },
            send() {

                let that = this;
                console.log(process.env.MIX_API_URL);

                that.submitButton = 'Sending';
                that.submitDisabled = true;

                axios.post(process.env.MIX_API_URL + '/send', {
                    recipient_name: that.formFields.recipient_name,
                    recipient_email: that.formFields.recipient_email,
                    your_name: that.formFields.your_name,
                    your_email: that.formFields.your_email,
                    your_comment: that.formFields.your_comment,
                })
                    .then(function (response) {
                        that.formFields = {}; //Clear input formFields.
                        Vue.$toast.open({
                            message: response.data,
                            type: "success",
                            duration: 5000,
                            dismissible: true
                        })
                        that.submitDisabled = false;
                        that.submitButton = 'Submit';
                        that.closeModal();
                    })
                    .catch(function (error) {

                        console.log('errors');
                        console.log(error.response.data);
                        console.log(error.response.data.errors);
                        that.formErrors = error.response.data.errors;

                        that.submitDisabled = false;
                        that.submitButton = 'Submit';


                    });


            },
            saveToFav() {
                console.log('Save To Fav');
                this.$swal.fire({
                    title: '<strong>Press <u>ctrl + D</u></strong>',
                    type: 'info',
                    html: 'You can add this page to your , ' +
                        'Bookmarks by pressing CTRL +D on your keyword.',
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText:
                        '<i class="fa fa-thumbs-up"></i> Great!',
                    confirmButtonAriaLabel: 'Thumbs up, great!',
                    cancelButtonText:
                        '<i class="fa fa-thumbs-down"></i>',
                    cancelButtonAriaLabel: 'Thumbs down'
                })

            },


            displayModal() {
                this.showModal = true;

            },

            closeModal() {

                this.showModal = false;

            },

        },
        mounted: function () {
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            }
        }
    }

</script>
<style>
    /*.modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 500px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }*/
</style>
